<template>
    <NuxtLayout>
        <NuxtPage :transition="transitionProps" />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {watch} from 'vue';
    import {useRoute, useRouter} from '@typed-router';
    import {NuxtPage} from '#components';
    import {useAsyncData, useHead, useHostSettings, useScripts} from '#imports';
    import {usePageSlideTransition} from '@malt/utils';
    import {useRouterStore} from './common/stores';

    const {data, error} = await useAsyncData('host-settings', () => useHostSettings(), {deep: true});
    if (!error.value) {
        const {loadScripts} = useScripts(data.value);
        useHead({script: await loadScripts()});
    }

    const transitionProps = usePageSlideTransition({
        pathsOrder: ['/', '/quote'],
    });

    const routerStore = useRouterStore();

    const route = useRoute();
    const router = useRouter();

    watch(
        [() => route, () => router],
        () => {
            routerStore.route = route;
            routerStore.router = router;
        },
        {deep: true, immediate: true},
    );
</script>

<style lang="scss">
    html {
        background-color: var(--joy-color-neutral-10);
        min-height: 100%;
    }
</style>
